import { Pet } from './pet';

export class PenBooking {
  sid: number;
  petType: string;
  petSids: number[] = [];
  pets: Pet[] = [];
}
